import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Report, RowActions } from '../../../../admin/report/report';
import { AlertDialogComponent } from '../../../../../shared/components/alert-dialog/alert-dialog.component';
import { DeletePromocodeService } from '../../../../admin/action/components/promocode/promocode-management/delete-promocode.service';
import { FetchPromocodeService } from '../../services/fetch-promocode.service';
import { GetPromocodeProductsService } from '../../services/get-promocode-products.service';
import { LanguageService } from '../../../../../shared/services/language.service';

@Component({
  selector: 'app-manage-promocode',
  templateUrl: './manage-promocode.component.html',
  styleUrls: ['./manage-promocode.component.scss']
})
export class ManagePromocodeComponent implements OnInit {
  searchKey!: string;
  searchId!: number;
  pages!: number;
  codeName: string = 'codeName';
  promocodeProducts: any[] = [];
  Columns = [
    'codeName',
    'precentage',
    // 'ProductName',
    'availableQuantity',
    'redeemedQuantity',
	'ticketQuantity',
	'redeemedTicketQuantity',
    'createdAt',
    'expiry',
  ];
  displayTableColumns;
  rowActions: RowActions[] = [
    {
      actionName: 'delete',
      actionType: 'icon',
      iconClass: 'fa-trash',
    },
    {
      actionName: 'edit',
      actionType: 'icon',
      iconClass: 'fa-edit',
    },
    {
      actionName: 'View Product',
      actionType: 'icon',
      iconClass: 'fa-eye',
    },
  ];
  filterField: any[] = [];
  totalNumberOfRecords = 0;
  promocodeReportData: any[] = [];
  requestBody: Report = {};
  loading: boolean = false;
  reportName: string = '';

  constructor(
    private translate: TranslateService,
    private languageService: LanguageService,
    public fetchpromocodeService: FetchPromocodeService,
    public GetPromocodeProducts: GetPromocodeProductsService,
    private deletePromocodeService: DeletePromocodeService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }

  async ngOnInit() {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        this.loadArContent();
      } else if (localStorage.getItem("language") === "en") {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === "ar") {
        this.loadArContent();
      } else if (lang === "en") {
        this.loadEnContent();
      }
    });
    this.fetchpromocodeService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  loadArContent() {
    this.translate.use('ar');
    this.reportName = 'إدارة البروموكود';
    this.displayTableColumns = {
      'codeName': 'إسم البروموكود',
      'precentage': 'النسبة',
      'availableQuantity': 'الكمية المتاحة',
      'redeemedQuantity': 'الكمية المستردة',
	  'ticketQuantity': 'التذاكر المتاحة',
	  'redeemedTicketQuantity': 'التذاكر المتاحة',
      'createdAt': 'الإنتاج',
      'expiry': 'إنتهاء الصلاحية',
    };

    this.filterField = [
      {
        filterFieldName: 'expired',
        filterDisplayName: 'الحالة',
        defaultValue: '',
        filterOptions: [
          { key: 'إظهار الكل', value: null },
          { key: 'منتهي الصلاحية', value: 1 },
          { key: 'غير منتهي الصلاحية', value: 0 },
        ]
      },
    ];
  }

  loadEnContent() {
    this.translate.use('en');
    this.reportName = 'Promocode Mangement';
    this.displayTableColumns = {
      'codeName': 'Promocode Name',
      'precentage': 'Percentage',
      'availableQuantity': 'Available Quantity',
      'redeemedQuantity': 'Redeemed Quantity',
	  'ticketQuantity': 'Available Tickets',
	  'redeemedTicketQuantity': 'Redeemed Tickets',
      'createdAt': 'Creation',
      'expiry': 'Expiry',
    };

    this.filterField = [
      {
        filterFieldName: 'expired',
        filterDisplayName: 'Status',
        defaultValue: '',
        filterOptions: [
          { key: 'Show All', value: null },
          { key: 'Expired', value: 1 },
          { key: 'Not Expired', value: 0 },
        ]
      },
    ];
  }

  async filter(event: any) {
    console.log('object is', event);
    if (event && Object.keys(event).length) {
      console.log('filter should not be null');
      this.requestBody.filterOptions = event;
    } else {
      console.log('filter should be null');
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.fetchpromocodeService
      .loader()
      .subscribe((val: any) => {
        this.loading = val;
      });
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.fetchpromocodeService
      .loader()
      .subscribe((val: any) => {
        this.loading = val;
      });
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.fetchpromocodeService
        .loader()
        .subscribe((val: any) => {
          this.loading = val;
        });
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.fetchpromocodeService
      .loader()
      .subscribe((val: any) => {
        this.loading = val;
      });
  }

  async updateTable() {
    this.fetchpromocodeService.activateLoader();
    this.fetchpromocodeService.setParams(this.requestBody);
    const report = await this.fetchpromocodeService.make();
    this.promocodeReportData = report.result.map((i) => {
      Object.keys(i).forEach(k =>{
        i[k] = i[k] ? i[k] : '0' ;
      })
      return i;
    });
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async onRowAction(event: any) {
    if (event.action === 'delete') {
      this.deletePromocode(event.key.id);
    }
    if (event.action === 'edit') {
      // console.log(event.key)
      this.router.navigate(['/seller/promo-code/edit/', event.key.codeName]);
    }
    if (event.action === 'copy') {
      // console.log(event.key);
      this.copyInputMessage(event.key);
    }
    if (event.action === 'View Product') {
      await this.openProductPopup(event.key.id);
    }
  }

  async openProductPopup(promocodeId: number) {
    this.GetPromocodeProducts.setParams({ promocodeId });
    let products = await this.GetPromocodeProducts.make();
    this.promocodeProducts = products.products.map((product: any) => {
      return product.NewProduct;
    });
  }
  closePopup() {
    this.promocodeProducts = [];
  }

  async deletePromocode(id: number) {
    // console.log(id);
    try {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: this.translate.instant('Sellers.Products.SureWantDelete'),
          question: true
        }
      });
      const result = await dialogRef.afterClosed().toPromise();
      if (!result) {
        return;
      }
      this.deletePromocodeService.setParams({ id });
      const res = await this.deletePromocodeService.make();
      this.updateTable();
      this.fetchpromocodeService
        .loader()
        .subscribe((val: any) => {
          this.loading = val;
        });
    } catch (err) {
      console.log(err);
    }
  }


  copyInputMessage(text: any) {
    let message = '';
    try {
      const selBox = document.createElement('textarea') as HTMLTextAreaElement;
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.select();
      const success = document.execCommand('copy');
      document.body.removeChild(selBox);
      message = success ? this.translate.instant('Sellers.Products.CopiedToClipboard') : this.translate.instant('Sellers.Products.UnableToCopy');
    } catch (err) {
      message = this.translate.instant('Sellers.Products.UnableToCopy');
    } finally {
      this.snackBar.open(message, '', { duration: 2000 });
    }
  }

}
